<template>
  <v-container @click="focus" class="select_brightness" data-testid="select_brightness">
    <p v-if="label" class="select_brightness_label">{{ label }}</p>

    <div class="box">
      <span class="dot" :style="{ 'background-color': dotColour }"></span>
    </div>

    <v-slider
      ref="SelectBrightnessSlider"
      v-model="sliderValue"
      class="select_brightness_slider"
      :min="10"
      :max="100"
      @change="$emit('change', localValue)"
    >
      <template v-slot:prepend>
        <v-icon v-if="!phone_screen" @click="decrement">mdi-minus</v-icon>
      </template>

      <template v-slot:append>
        <v-icon v-if="!phone_screen" @click="increment">mdi-plus</v-icon>
      </template>
    </v-slider>

    <div
      class="select_brightness_percent"
      @mousedown.stop
      @mouseup.stop
      @click.stop
    >
      <v-text-field
        v-model.number="percentValue"
        type="number"
        outlined
        min="10"
        max="100"
        suffix="%"
        single-line
        hide-details
        @blur="commitPercentValue"
        @keydown.enter="commitPercentValue"
      ></v-text-field>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      percentInputValue: Math.round(Math.min(1, Math.max(0.1, this.value)) * 100),
    };
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    colour: {
      type: String,
      default: "red",
    },
  },
  computed: {
    ...mapState(["phone_screen"]),
    localValue: {
      get() {
        return Math.min(1, Math.max(0.1, this.value));
      },
      set(value) {
        this.$emit("input", Math.round(value * 100) / 100);
      },
    },
    sliderValue: {
      get() {
        return Math.round(this.localValue * 100);
      },
      set(value) {
        this.localValue = value / 100;
        this.percentInputValue = Math.round(value);
      },
    },
    percentValue: {
      get() {
        return this.percentInputValue;
      },
      set(value) {
        const percent = Number(value);
        if (!Number.isFinite(percent)) {
          return;
        }

        this.percentInputValue = percent;
      },
    },
    dotColour() {
      let base_colour = parseInt(255 * this.localValue);

      if (this.colour == "red") {
        return "rgb(" + base_colour + ",0,0)";
      } else if (this.colour == "blue") {
        return "rgb(0,0," + base_colour + ")";
      } else if (this.colour == "green") {
        return "rgb(0," + base_colour + ",0)";
      } else {
        return "rgb(" + base_colour + "," + base_colour + "," + base_colour + ")";
      }
    },
  },
  methods: {
    focus() {
      if (this.$refs["SelectBrightnessSlider"].$refs.thumb) {
        this.$refs["SelectBrightnessSlider"].$refs.thumb.focus();
      }
    },
    increment() {
      if (this.sliderValue < 100) {
        this.sliderValue += 1;
      }
    },
    decrement() {
      if (this.sliderValue > 10) {
        this.sliderValue -= 1;
      }
    },
    commitPercentValue() {
      const percent = Number(this.percentInputValue);
      if (!Number.isFinite(percent)) {
        this.percentInputValue = this.sliderValue;
        this.$emit("change", this.localValue);
        return;
      }

      const clampedPercent = Math.min(100, Math.max(10, percent));
      if (percent !== clampedPercent) {
        this.sliderValue = clampedPercent;
      } else {
        this.localValue = clampedPercent / 100;
      }
      this.percentInputValue = clampedPercent;
      this.$emit("change", this.localValue);
    },
  },
  watch: {
    value() {
      this.percentInputValue = this.sliderValue;
    },
  },
};
</script>

<style>
.select_brightness .box {
  background-color: black;
  text-align: center;
  vertical-align: center;
  height: 160px;
}

.select_brightness .dot {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 55px;
}

.select_brightness {
  padding: 20px;
}

.select_brightness .select_brightness_label {
  font-size: 1.1rem;
}

.select_brightness .select_brightness_slider {
  margin-top: 20px;
}

.select_brightness .select_brightness_percent {
  margin: 0 auto;
  max-width: 100px;
}

.select_brightness .select_brightness_percent input {
  text-align: center;
}

.phone-screen .select_brightness .box {
  height: 100px;
}

.phone-screen .select_brightness .dot {
  margin-top: 25px;
}

.phone-screen .select_brightness {
  padding: 10px;
}
</style>
